import { GetterTree } from 'vuex'
import { Auth } from './types'
import { RootState } from '../types'

export const getters: GetterTree<Auth, RootState> = {
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,
  isTokenValid: state => state.tokenValid,
  user: state => state.user,
  connection: state => state.connection,
  session: state => state.session,
  wsConnectionActive: state => state.wsConnectionActive
}
